import React from "react";
import CustomPostListStyles from "../../Styles/PostsViews/CustomPostList.module.css";
import Image from "../../Common/Image.component/Image";

const CustomPostList = ({ image, posts, names, createdAt }) => {
  const { container, figure, texts, body, asides } = CustomPostListStyles;

  return (
    <div className={`container-fluid mt-3 ${container}`}>
      <section className={` card-body d-flex ${body}`}>
        <figure className={`card-img ${figure}`}>
          {image ? (
            <Image
              src={image}
              alt={"posters image"}
              className={`card-img img`}
              width="100%"
              height="inherit"
            />
          ) : (
            <div className={`card-text ${texts}`}>cv</div>
          )}
        </figure>
        <aside className={`${asides}`}>
          <div style={{ color: "#aaa" }}>
            <span>{names}</span> <span>{createdAt}</span>
          </div>

          <div style={{ color: "#fff" }}>
            <p>{posts}</p>
          </div>
        </aside>
      </section>
    </div>
  );
};

export default CustomPostList;
